import loadScript from '@/helper/loadscript';
import { getOpenid, clearOpenid } from './openid-manger';
import { loginByOppoOid, loginByYoupin } from '@/apis/base';
import parse from 'url-parse';
import Cookies from 'js-cookie';
import { isAliPayMiniProgram, isMiniProgram } from '@/helper/uaCheck';
import { Toast } from 'mint-ui';

// 与oppo 商量好的登录方式
export const toOppoLogin = async function (resolvedNextRoute) {
  let oppoHost = 'https://www.opposhop.cn/recycle';
  let jsUrl = 'https://id.oppo.com/resources/js/oppo.login.js';
  // 测试环境才会注入 该cookie
  if (Cookies.get('hsb_test_env') || process.env.NODE_ENV !== 'production') {
    oppoHost = 'https://test-opposhop-out.wanyol.com/recycle';
    jsUrl = 'https://newucweb-ucnewtest.wanyol.com/resources/js/oppo.login.js';
  }
  /**
   * 发现过为空的情况，但还没找到重现方法
   * 2018-07-30
   */
  const urlObj = parse(window.location.href, true);
  const pid = urlObj.query.pid || '1384';
  const loginCallBack = window.location.origin + resolvedNextRoute.href;
  const openid = getOpenid();
  const oppocallback = `https://api.huishoubao.com/api/oauth/oppoCallBack?pid=${pid}&redirect_uri=${encodeURIComponent(loginCallBack)}`;
  const isFromAliyPg = await isAliPayMiniProgram();
  const isFromWxPg = await isMiniProgram();
  let oppoCallBackUrl = `/pages/login/login?option=navigateBack&url=${encodeURIComponent(oppocallback)}`;
  if (isFromAliyPg) {
    // console.log('支付宝JSAPI', window.my);
    window.my && window.my.navigateTo({url: oppoCallBackUrl});
    return;
  }
  if (isFromWxPg) {
    loadScript('https://res.wx.qq.com/open/js/jweixin-1.4.0.js', () => {
      window.wx && window.wx.miniProgram && window.wx.miniProgram.navigateTo({url: oppoCallBackUrl});
    });
    return;
  }
  if (openid) {
    try {
      const res = await loginByOppoOid(openid);
      if (res.success && res._data) {
        window.location.href = `${loginCallBack}&token=${res._data.token}`;
        return;
      }
      clearOpenid();
    } catch (err) {
      clearOpenid();
      console.log(err);
    }
  }
  if (window !== window.top) {
    setTimeout(function () {
      window.parent.postMessage(JSON.stringify({
        evenId: 2,
        data: {
          callBack: oppocallback
        }
      }), oppoHost);
    }, 1000);
  } else {
    loadScript(jsUrl, function () {
      var h5Login = oppoHost + '?redirect=' + window.encodeURIComponent(oppocallback);
      window.oppo.win.open(h5Login);
      if (!toOppoLogin.loaded) {
        toOppoLogin.loaded = true;
        const colseOppoLogin = () => {
          window.oppo && window.oppo.win && window.oppo.win.closeWindow && window.oppo.win.closeWindow();
        };
        window.addEventListener('popstate', colseOppoLogin);
        window.addEventListener('unload', colseOppoLogin);
      }
    });
  }
};

export const toColaLogin = async function (resolvedNextRoute) {
  const urlObj = parse(window.location.href, true);
  const pid = urlObj.query.pid || '1439';
  const loginCallBack = window.location.origin + resolvedNextRoute.href;
  const openid = getOpenid();
  const colaCallback = `https://api.huishoubao.com/api/oauth/youpinCallBack?pid=${pid}&redirect_uri=${encodeURIComponent(loginCallBack)}`;
  const openColaLogin = () => {
    const loginUrl = `https://api.huishoubao.com/api/user/oauthLogin?redirectUri=${encodeURIComponent(loginCallBack)}&platform=5&pid=${pid}&oauthSite=youpin`;
    window.location.href = loginUrl;
  };
  if (openid) {
    window.location.href = `${colaCallback}&openId=${openid}`;
    return true;
  }
  openColaLogin();
};
export const toColaNewLogin = async function (resolvedNextRoute) {
  const openId = getOpenid();
  const { href } = resolvedNextRoute;
  const map = ['hsbh5', 'cocoh5'];
  let projectName = 'hsbh5';
  for (let i = 0; i < map.length; i++) {
    if (href.indexOf(map[i]) !== -1) {
      projectName = map[i];
      break;
    }
  }
  if (openId) {
    const res = await loginByYoupin({openId});
    if (+res._errCode === 0) {
      window.location.href = `/${projectName}${resolvedNextRoute.route.query.redirect}&token=${res._data.token}`;
    } else {
      Toast(res._errStr);
    }
    return true;
  }
  loadScript('https://s1.huishoubao.com/colagoods/app/cola-sdk.2.3.8.js', async () => {
    const result = await window.cola.login();
    if (result.token) {
      const res = await loginByYoupin({openId: result.token});
      if (+res._errCode === 0) {
        window.location.href = `/${projectName}${resolvedNextRoute.route.query.redirect}&token=${res._data.token}`;
      } else {
        Toast(res._errStr);
      }
    } else {
      Toast(result._errStr);
    }
  });
};



// WEBPACK FOOTER //
// ./src/core/login/login-functions.js